<template>
  <div class="divCommonPageButton">
    <!-- <div
      class="divSubject"
      @click="jumpSubject(item.url, item.desc)"
      v-if="item && item.desc"
    >
      <img
        style="margin: 14px 21px 6px 19px; width: 47px"
        v-if="item.id == 0"
        :src="item.img"
      />
      <img v-if="item.id != 0" :src="item.img" />
      <div v-if="item.id != 0">{{ item.desc }}</div>
    </div> -->
    <div class="divContainer">
      <div class="divConsult" @click="qimoChatClick('在线咨询')">
        <img src="./../../assets/common/img/btn_kefu.png" width="40px" />
        <div class="fonts">在线咨询</div>
      </div>
      <!-- <div class="divListen" @click="qimoChatClick('就业薪资')">
        <img src="./../../assets/common/img/listen.png" />
        <img
          src="./../../assets/common/img/listen_hover.png"
          class="img_hover"
        />
        <div>就业薪资</div>
      </div> -->
    </div>
    <div class="divGoTop" @click="goTop">
      <img src="./../../assets/common/img/btn_backtop.png" width="40px" />
      <div class="fonts">回到顶部</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: 0,
      items: [
        {
          id: "0",
          desc: "传智教育",
          url: "http://www.itcast.cn",
          img: "img/common/chuanzhi.png",
        },
        {
          id: "1",
          desc: "Java学院",
          url: "http://java.itcast.cn/?javaeezly",
          img: "img/common/java.png",
        },
        {
          id: "2",
          desc: "前端学院",
          url: "http://web.itcast.cn/?webzly",
          img: "img/common/web.png",
        },
        {
          id: "3",
          desc: "Python学院",
          url: "http://python.itcast.cn/",
          img: "img/common/python.png",
        },
        {
          id: "8",
          desc: "人工智能学院",
          url: "http://ai.itcast.cn/?aizly$javaeezly",
          img: "img/common/ai.png",
        },
        {
          id: "7",
          desc: "大数据学院",
          url: "http://www.itcast.cn/subject/pythonzly",
          img: "img/common/bigdata.png",
        },
        {
          id: "6",
          desc: "设计学院",
          url: "http://www.itcast.cn/subject/uizly/index.shtml",
          img: "img/common/design.png",
        },
        {
          id: "5",
          desc: "产品经理学院",
          url: "http://www.itcast.cn/subject/pmzly/index.html",
          img: "img/common/product.png",
        },
        {
          id: "4",
          desc: "测试学院",
          url: "http://test.itcast.cn/?testzly",
          img: "img/common/test.png",
        },
      ],
      item: {},
      localHeight: 0,
      speed: 100,
    };
  },
  watch: {
    $route() {
      let url = this.$router.currentRoute.path;
      if (url === "/bishe") {
        this.item = "";
        return false;
      }
      let subjectID = sessionStorage.getItem("subjectID")
        ? sessionStorage.getItem("subjectID")
        : "1";
      this.item = this.items.filter((item) => item.id === subjectID)[0];
    },
  },
  mounted() {
    let subjectID = sessionStorage.getItem("subjectID")
      ? sessionStorage.getItem("subjectID")
      : "1";
    this.item = this.items.filter((item) => item.id === subjectID)[0];
    this.height = document.documentElement.clientHeight;
    Object.freeze(this.height);
    Object.freeze(this.items);
    Object.freeze(this.item);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let ele = document.querySelector(".divGoTop");
      if (!ele) {
        return;
      }
      if (
        document.body.scrollTop > this.height ||
        document.documentElement.scrollTop > this.height
      ) {
        ele.style.display = "block";
      } else {
        ele.style.display = "none";
      }
    },
    qimoChatClick(name) {
      this.$trackEvent(name, "点击图标", name);
      window.qimoChatClick();
    },
    jumpSubject(url, name) {
      this.$trackEvent("学院图标", "点击图标", name);
      window.open(url, "_blank");
    },
    goTop() {
      this.$trackEvent("回到顶部", "点击图标", "回到顶部");
      this.localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.moveUp();
    },
    moveUp() {
      if (this.localHeight > this.speed) {
        this.localHeight -= this.speed;
        document.body.scrollTop = this.localHeight;
        document.documentElement.scrollTop = this.localHeight;
        setTimeout(this.moveUp, 10);
      } else {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.divCommonPageButton {
  background: #ffffff;
  border-radius: 8px 0px 0px 8px;
  box-shadow: 0px 1px 7px 2px rgba(0,0,0,0.11); 
  position: fixed;
  right: 0px;
  text-align: center;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 9999;
  .divSubject {
    height: 92px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.11);
    margin-bottom: 13px;
    cursor: pointer;
    &:hover div {
      color: #1286FF;
    }
    img {
      width: 40px;
      margin: 14px 21px 6px 22px;
    }
  }
  .divContainer {
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.11);
     border-radius: 6px 0 0 6px;
    .divConsult {
      // height: 92px;
      // background: #1286FF;
      // border-top-left-radius: 6px;
      // border-top-right-radius: 6px;
     
      cursor: pointer;
      position: relative;
      display: block;
      img{
        position: absolute;
        left: 8px;
        top: 20px;
      }
      .fonts {
        visibility:hidden;
        width: 28px;
        padding: 20px 13px;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        line-height: 17px;
        color: #1286FF;
      }
      &:hover img {
        display: none;
      }
      &:hover .fonts{
        visibility:initial;
      }
    }
    .divListen {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-width: 0;
      color: #1286FF;
      cursor: pointer;
      position: relative;
      display: block;
      div {
        width: 28px;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        line-height: 17px;
        color: #1286FF;
      }
    }
  }

  .divGoTop {
    background: #ffffff;
    border-radius: 0 0 0 6px;
    cursor: pointer;
    position: relative;
    display: none;
    &::before{
      content: '';
      position: absolute;
      top: 2px;
      left: 12px;
      height: 1px;
      width: 34px;
      background: #e2e3e5;
    }
    img{
      position: absolute;
      left: 8px;
      top: 20px;
    }
    .fonts {
      visibility:hidden;
      width: 28px;
      padding: 20px 13px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      line-height: 17px;
      color: #1286FF;
    }
    &:hover img {
      display: none;
    }
    &:hover .fonts{
      visibility:initial;
    }
  }
}
</style>
